import { Input } from "react-aria-components";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";

export function MemberProfileMedicationManagementServices() {
  return (
    <DashboardCard2
      classNameChildren="tw:flex tw:items-center tw:gap-2"
      title="Medication Management Services"
    >
      <Input checked className="AddPatientInput tw:h-4" disabled type="checkbox" />
      Medication Consult Requested
    </DashboardCard2>
  );
}
